import React from 'react';

// This component is now just a placeholder as we've moved the actual
// cookie consent initialization to the index.html file for more reliable loading
const CookieConsent = () => {
  return null;
};

export default CookieConsent; 